import React, { Component } from 'react';
import logo from './logo.svg';
import Index from './pages/Index';
import Home from './pages/home/Home';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import './App.css';

class App extends Component {
  render() {
    return (
      <div className="App container-fluid">
        <header className="App-header">
          {/* <img src={logo} className="App-logo" alt="logo" />
          <h1 className="App-title">Welcome to React</h1> */}
        </header>
        <div className="App-intro">
          <BrowserRouter>
            <Switch>
              <Route path="/login" exact component={Index} />
              <Route path="/home" exact component={Home} />
              <Route path="*" component={Index} />
            </Switch>
          </BrowserRouter>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js